import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

import * as firebase from '@/services/firebase'

import { firebaseAuth, firebaseDatabase } from '@/services/firebase'

const mapAuthProviders = {
  firebase: {
    login: firebase.login,
    register: firebase.register,
    currentAccount: firebase.currentAccount,
    logout: firebase.logout,
  },
}

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    id: '',
    name: '',
    role: '',
    email: '',
    avatar: '',
    authorized: process.env.VUE_APP_AUTHENTICATED || false, // false is default value
    loading: false,
    channelLoading: false,
    attemptedConnection: false,
    subscriptionStatus: 'active',
    lifetimeStatus: false,
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
    setStripeInfo(state, payload) {
      state.subscriptionStatus = payload
    },
    setLifetime(state) {
      state.lifetimeStatus = true
    },
  },
  actions: {
    LOGIN({ commit, dispatch, rootState }, { payload }) {
      const { email, password } = payload
      commit('SET_STATE', {
        loading: true,
      })

      const login = mapAuthProviders[rootState.settings.authProvider].login
      login(email, password).then(success => {
        if (success) {
          dispatch('LOAD_CURRENT_ACCOUNT')
          // Vue.prototype.$notification.success({
          //   message: 'Logged In',
          //   description: 'You have successfully logged in to PlannerVid!',
          // })
        }
        if (!success) {
          commit('SET_STATE', {
            loading: false,
          })
        }
      })
    },
    REGISTER({ commit, dispatch, rootState }, { payload }) {
      const { email, password, name } = payload
      commit('SET_STATE', {
        loading: true,
      })
      const register = mapAuthProviders[rootState.settings.authProvider].register
      register(email, password, name).then(success => {
        if (success) {
          dispatch('LOAD_CURRENT_ACCOUNT')
          router.push('/createaccount-step-2')
        }
        if (!success) {
          commit('SET_STATE', {
            loading: false,
          })
        }
      })
    },
    LOAD_CURRENT_ACCOUNT({ commit, rootState }) {
      commit('SET_STATE', {
        loading: true,
      })

      const currentAccount = mapAuthProviders[rootState.settings.authProvider].currentAccount
      currentAccount().then(response => {
        if (response) {
          console.log(response)
          const { id, email, displayName, avatar, role } = response
          commit('SET_STATE', {
            id,
            displayName,
            email,
            avatar,
            role,
            authorized: true,
          })
          // get subscription status
          firebaseDatabase.collection('creators')
            .doc(firebaseAuth.currentUser.uid)
            .collection('subscriptions')
            .where('status', 'in', ['trialing', 'active', 'lifetime'])
            .get()
            .then(querySnapshot => {
              querySnapshot.forEach(doc => {
                console.log(doc.id)
                const status = doc.data().status
                commit('setStripeInfo', status)
                // check for lifetime access
                if (status === 'lifetime') {
                  commit('setLifetime')
                }
              })
              if (querySnapshot.empty) {
                console.log('querySnapshot.empty')
                commit('setStripeInfo', 'canceled')
              }
            })
        }
        commit('SET_STATE', {
          loading: false,
        })
      })
    },
    LOGOUT({ commit, rootState }) {
      const logout = mapAuthProviders[rootState.settings.authProvider].logout
      logout().then(() => {
        commit('SET_STATE', {
          id: '',
          name: '',
          role: '',
          email: '',
          avatar: '',
          authorized: false,
          loading: false,
        })
        router.push('/auth/login')
      })
    },
  },
  getters: {
    user: state => state,
  },
}
